const features = [
  {
    icon: 'ri-radar-line',
    title: '全网实时监控',
    desc: '覆盖微博、抖音、小红书等50+主流平台，智能算法7×24小时不间断扫描，确保每一条热门黑料和明星八卦都能第一时间被捕获。',
  },
  {
    icon: 'ri-shield-check-line',
    title: '多方交叉验证',
    desc: '每一条爆料均经过多渠道交叉核实，标注可信度等级。实锤内容附有完整证据链，让吃瓜吃得放心、吃得明白。',
  },
  {
    icon: 'ri-search-eye-line',
    title: '精准快速搜索',
    desc: '强大的话题标签系统和热搜榜单功能，让您可以按明星、事件、类型等多维度精准定位想看的爆料内容。',
  },
];

export default function Features() {
  return (
    <section id="features" className="py-12 md:py-16 px-4 md:px-6 bg-background-50">
      <div className="max-w-[1000px] mx-auto">
        <div className="text-center mb-8">
          <span className="inline-block text-xs font-semibold uppercase tracking-widest text-accent-500 mb-2">Features</span>
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-900">平台特色</h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-5">
          {features.map((feat, i) => (
            <div key={i} className="bg-background-100 border border-background-200/70 rounded-xl p-6 text-center group hover:border-background-300 transition-all cursor-pointer">
              <div className="w-14 h-14 flex items-center justify-center rounded-2xl bg-primary-100 text-primary-500 mx-auto mb-4 group-hover:bg-primary-500 group-hover:text-background-50 transition-colors">
                <i className={`${feat.icon} text-2xl`}></i>
              </div>
              <h3 className="font-heading text-base font-bold text-foreground-900 mb-2">{feat.title}</h3>
              <p className="text-xs text-foreground-500 leading-relaxed">{feat.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}